<template>
  <v-app-bar app class="nav-top">
    <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    <!-- breadcrumbs -->
    <v-breadcrumbs v-if="breadcrumbs.length" :items="breadcrumbs" large>
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :to="breadcrumbNameRoute(item)"
          :disabled="item.disabled"
        >
          {{ $t(item.text) }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <!-- END breadcrumb -->
    <v-spacer />
    <v-btn class="mr-1" @click.stop="settings = !settings" icon>
      <v-icon>mdi-cog-outline</v-icon>
    </v-btn>

    <item-bar-notification/>

    <item-bar-profile/>
  </v-app-bar>
</template>

<script>
// Utilities
import { get, sync } from 'vuex-pathify'
import ItemBarNotification from './ItemBarNotification'
import ItemBarProfile from './ItemBarProfile'
export default {
  name: 'DefaultAppBar',
  components: {
    ItemBarNotification,
    ItemBarProfile
  },
  computed: {
    drawer: sync('app/drawer'),
    settings: sync('app/settings'),
    locale: get('app/locale'),
    breadcrumbs: get('breadcrumb/items'),
    avatar: get('user/avatar')
  },
  methods: {
    breadcrumbNameRoute(item) {
      if (typeof item.to === 'string') {
        return { name: item.to }
      }
      return item.to
    }
  }
}
</script>
